import SubHeaderMenu from './SubHeaderMenu'

export default function SubHeaderDesktop() {
  return (
    <ul className="hidden rounded-full w-full lg:items-center lg:justify-end lg:flex">
      <SubHeaderMenu />
    </ul>
  )
}
